module.exports = __webpack_public_path__ + "static/marker_frage_hover-9b2fa251b9002f23378538512340c7d7.png";